import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStoreDetails(id) {
  const response = await sendRequest(id)
  const parsedResponse = parseResponse(response, id)
  return parsedResponse
}

async function sendRequest(id) {
  let url = `${urls.getStoreDetails}${id}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const data = Formatter.parseExternalStore(rawData)

    return {
      statusCode: 200,
      data: data,
    }
  }
  return {
    statusCode: 404,
    message: 'store not found',
  }
}

export { getStoreDetails }
